import { registerPlugin, Capacitor } from '@capacitor/core';

// CallKit bridge (iOS only). Reporting calls to CallKit makes iOS take over
// system-wide audio routing, which defaults to the built-in receiver
// (earpiece). Without this, WKWebView's WebRTC stack hardcodes
// .videoChat + .defaultToSpeaker on its own AVAudioSession (in a separate
// XPC process) and call audio is permanently routed to the loud-speaker.
let CallKit;
if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
  CallKit = registerPlugin('CallKit');
} else {
  CallKit = null;
}

// Safe invoker (no-op on non-iOS, swallows plugin errors).
export const callKitSafe = async (fn) => {
  if (!CallKit) return null;
  try {
    return await fn(CallKit);
  } catch (e) {
    console.warn('[CallKit] call failed:', e?.message || e);
    return null;
  }
};

export default CallKit;
